<form
  nz-form
  [formGroup]="form"
  (ngSubmit)="submit()"
  nzLayout="horizontal"
  *ngIf="allowed"
  appGuideAnchor="date-of-manufacture-first"
>
  <nz-input-group
    *ngIf="canCheckProductionDate$ | async"
    appGuideAnchor="date-of-manufacture-second"
  >
    <input
      nz-input
      type="text"
      formControlName="vinManufacture"
      placeholder="{{ 'FRAME_NUMBER' | translate }}"
      (focus)="inputFocus.emit()"
    />
    <button
      *ngIf="!this.checkFail || this.currentUser.isAuctioneer"
      nz-button
      nzType="primary"
      [nzLoading]="loading$ | async"
    >
      {{ 'CHECK_DATE_OF_MANUFACTURE' | translate }}
    </button>
    <button
      *ngIf="this.checkFail && !this.currentUser.isAuctioneer"
      nz-button
      nzType="primary"
      [disabled]="cantRequestCheckProductionDate$ | async"
      [nzLoading]="loading$ | async"
      nz-tooltip
      [nzTooltipTitle]="'PRODUCTION_DATE_CHECK_REQUEST_LIMIT_REACHED' | translate"
      [nzTooltipTrigger]="(cantRequestCheckProductionDate$ | async) ? 'hover' : null"
    >
      {{ 'CREATE_PRODUCTION_DATE_CHECK_REQUEST' | translate }}
    </button>
  </nz-input-group>
</form>
